// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"65dc8c4e","450":"bf411dbf","511":"d8d1f88f","571":"eda44eea","717":"87415c24","800":"bc0dafcd","875":"548a0da1","993":"ac4cae83"}[chunkId] + ".chunk.js";
};